import fallbackImage from "../../../../../../assets/fallback_images/collectionSt.webp";
import { ICollection } from "../../../../../../entities/Collection/CollectionTypes";
import { LazyImg } from "../../../../../LazyImg";
import MainHeaderStore from "../../../../stores/MainHeaderStore";
import useMainHeaderSearchItem from "../helpers/useMainHeaderSearchItem";
import s from "./MainHeaderSearchCollection.module.scss";

interface Props {
  address: string;
  headerStore: MainHeaderStore;
  info: ICollection;
}

export const MainHeaderSearchCollection = ({
  address,
  headerStore,
  info,
}: Props): JSX.Element => {
  const { onClick } = useMainHeaderSearchItem({ headerStore, address });

  return (
    <div onClick={onClick} className={s.search_result_item}>
      <div className={s.search_result_item_l}>
        <div className={s.search_result_item_img}>
          <LazyImg
            imgUrl={info.contractData.metadata.image}
            fallbackImgURL={fallbackImage}
            alt={info.contractData.metadata.name ?? "Collection image"}
            reserveImgUrl={info.contractData.previews.at(-1)?.url}
          />
        </div>
        <div className={s.search_result_item_text}>
          <p>{info.contractData.metadata.name}</p>
          <p>{info.metadata.nftCount ?? 0} items</p>
        </div>
      </div>
      <div className={s.search_result_item_r}>
        {info.statistics.floorPriceSale ?? "--"} TON
      </div>
    </div>
  );
};
